import _orderBy from 'lodash/orderBy';
import { getEntriesListApi } from 'api/client';
import { getCurrentUtcDTStr } from 'utils/dateTime';

const defaultState = [];

const UPDATE_RECORD_STATE = 'userGameResultRecords/UPDATE_RECORD_STATE';

const reducer = (state = defaultState, action) => {
    switch (action.type) {
        case UPDATE_RECORD_STATE:
            return action.payload;
        default:
            return state;
    }
};

export default reducer;

export function updateGameResultRecords() {
    return async (dispatch, getState) => {
        const {
            promo: { uuid: promoUUID }
        } = getState();
        const {
            payload: { items: entries = [] }
        } = await getEntriesListApi(promoUUID);

        dispatch({
            type: UPDATE_RECORD_STATE,
            payload: _orderBy(entries, ['id'])
        });
        return entries;
    };
}

export const entryFlowKeys = {
    SIGN_UP_FORM: 'formSignUp',
    LOTTERY_PARTICIPANT: 'lotteryParticipant',
    LOTTERY_INSTANT: 'lotteryInstant'
};
export function updateFlowOfEntryRecord({ entryUUID, key }) {
    return (dispatch, getState) => {
        const { userGameResultRecords = [] } = getState();
        dispatch({
            type: UPDATE_RECORD_STATE,
            payload: userGameResultRecords.map(r =>
                r.uuid === entryUUID
                    ? { ...r, flow: { ...r.flow, [key]: getCurrentUtcDTStr() } }
                    : r
            )
        });
    };
}
